import React, { useEffect, useMemo } from 'react';
import { AppGrid } from 'src/components/App';
import { useColumns } from './useColumns';

const ReportGrid = ({ tenantId, userId, loading, resellersUsersReport, resellerFilters, ...props }) => {
  const { data, paging, filters } = resellersUsersReport;

  useEffect(() => {
    fetchData(filters, paging);
  }, [resellerFilters]);

  const columns = useColumns(data, 'user', tenantId);

  const fetchData = (filters, paging) => {
    props.fetchResellerUserReport(tenantId, userId, filters, paging, resellerFilters);
  };

  const handleTableChange = ({ pageNo, perPage }) => {
    fetchData(filters, {
      pageNo,
      perPage,
    });
  };

  return (
    <>
      <AppGrid
        selectableRows="none"
        columns={columns}
        data={data}
        loading={loading.resellersUsersReport}
        onTableChange={handleTableChange}
        options={{
          pagination: true,
          serverSide: true,
          page: paging.pageNo,
          rowsPerPage: paging.perPage,
          count: paging.count,
        }}
      />
    </>
  );
};

ReportGrid.propTypes = {};

export default ReportGrid;
